module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_9006.3b4c2b54.png";